import React from 'react';
import { motion } from 'framer-motion';

export default function BackArrow({ onClick, className = '', size = 'normal' }) {
  const isSmall = size === 'small';
  const buttonPadding = isSmall ? 'p-1' : 'p-2';
  const svgSize = isSmall ? 20 : 28;
  
  return (
    <motion.button
      data-testid="back-button"
      onClick={onClick}
      className={`${buttonPadding} rounded-full transition-all hover:scale-110 ${className}`}
      whileHover={{ x: -3 }}
      whileTap={{ scale: 0.9 }}
      style={{
        background: 'linear-gradient(135deg, #FFF9E6 0%, #FFE4B5 100%)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15), inset 0 2px 0 rgba(255,255,255,0.5)',
        border: isSmall ? '2px solid #D4A574' : '3px solid #D4A574'
      }}
    >
      <svg 
        width={svgSize} 
        height={svgSize} 
        viewBox="0 0 28 28" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ filter: 'drop-shadow(1px 1px 0px rgba(0,0,0,0.1))' }}
      >
        {/* Hand-drawn style arrow */}
        <path 
          d="M18 6C18 6 10 13 10 14C10 15 18 22 18 22" 
          stroke="#5D4E37" 
          strokeWidth="3.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          style={{
            filter: 'drop-shadow(0.5px 0.5px 0px rgba(255,255,255,0.8))'
          }}
        />
        {/* Decorative curl */}
        <path 
          d="M12 14C11 14.5 10 14 10 14" 
          stroke="#8B7355" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
      </svg>
    </motion.button>
  );
}
